export const stopStream = (videoRef, callBack) => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
      videoRef.current.srcObject = null;
      callBack?.();
    }
  }

export const checkIfOnlyText = (value) => {
  var pattern = new RegExp(/^[A-Za-z_ ]*$/);
  return pattern.test(value);
}

export const checkAgeGreaterThanEighteen = (selectedDate) => {
  const dob = new Date(selectedDate);
  const today = new Date();
  const yearDiff = today.getFullYear() - dob.getFullYear();
  if (yearDiff > 18) {
      return true;
  }
  if (yearDiff === 18) {
      const monthDiff = today.getMonth() - dob.getMonth();
      if (monthDiff > 0) {
          return true;
      }
      if (monthDiff === 0) {
          const dayDiff = today.getDate() - dob.getDate();
          if (dayDiff >= 0) {
              return true;
          }
          return false;
      }
      return false;
  }
  return false;
}